import { MarkStoryAsReadyToPublishMeta, MarkStoryAsReadyToPublishPayload } from 'types/store/MarkStoryAsReadyToPublish';
import { createAsyncReducer } from 'utils/Redux';

import { markStoryAsReadyToPublishActions } from '../actions';

export default createAsyncReducer<MarkStoryAsReadyToPublishMeta, MarkStoryAsReadyToPublishPayload>(markStoryAsReadyToPublishActions);
